// export const API_BASE_URL = 'http://localhost:5000/api';
export const API_BASE_URL = 'https://midtronix.online/api';

// Absolute URL for company logo (required for email; works in view/print/download too)
export const COMPANY_LOGO_URL = 'https://midtronix.online/midtronix_logo.png';

/**
 * DB stores paths like `uploads/items/file.webp`. Express serves them at the API
 * host as `/uploads/...` (see server.js). Default: `${apiOrigin}/uploads/...`.
 *
 * If your host only exposes files under a subpath (e.g. `/admin/backend/uploads`),
 * set REACT_APP_PUBLIC_UPLOADS_PREFIX=/admin/backend at build time.
 */
const apiOrigin = API_BASE_URL.replace(/\/api\/?$/, '');
const envUploadsPrefix = process.env.REACT_APP_PUBLIC_UPLOADS_PREFIX;

/** Path between apiOrigin and `uploads/...` (e.g. "" or "/admin/backend"). */
export function getPublicUploadsPrefix() {
  if (envUploadsPrefix !== undefined) {
    return String(envUploadsPrefix).replace(/\/$/, '');
  }
  // Always use /uploads at the API origin — works for production and for
  // `npm start` on localhost while API_BASE_URL points at midtronix.online.
  return '';
}

/** Full URL for a path stored in the DB (e.g. uploads/items/file.webp). */
export function getPublicFileUrl(relativePath) {
  if (relativePath == null || relativePath === '') return '';
  const normalized = String(relativePath).replace(/\\/g, '/').replace(/^\/+/, '');
  const prefix = getPublicUploadsPrefix().replace(/\/$/, '');
  const base = prefix ? `${apiOrigin}${prefix}` : apiOrigin;
  return `${base}/${normalized}`;
}
